// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"e3d73c1f","47":"11bdc589","54":"62b74d48","781":"6fd9b225"}[chunkId] + ".chunk.js";
};